import { getPaymentMethodKey, getPaymentMethodLabel } from "~/modules/Products/utils/paymentMethodLabel";

export interface PaymentMethodOrder {
  paymentGateway?: string | null;
  paymentMethodType?: string | null;
  price?: { amount?: number | null } | null;
}

export interface PaymentMethodRow {
  key: string;
  label: string;
  transactions: number;
  /** Actually charged, in cents. */
  paid: number;
  /** Share of all transactions, 0–1. */
  transactionsShare: number;
  /** Share of all revenue, 0–1. */
  paidShare: number;
}

/** How the buyers paid: transactions and revenue per gateway + method, most used first. */
export const aggregateByPaymentMethod = (orders: PaymentMethodOrder[]): PaymentMethodRow[] => {
  const byMethod = new Map<string, Omit<PaymentMethodRow, "transactionsShare" | "paidShare">>();
  let transactions = 0;
  let paid = 0;

  for (const order of orders) {
    const key = getPaymentMethodKey(order.paymentGateway, order.paymentMethodType);
    const amount = typeof order.price?.amount === "number" ? order.price.amount : 0;
    const row = byMethod.get(key) ?? {
      key,
      label: getPaymentMethodLabel(order.paymentGateway, order.paymentMethodType),
      transactions: 0,
      paid: 0,
    };

    row.transactions += 1;
    row.paid += amount;
    byMethod.set(key, row);
    transactions += 1;
    paid += amount;
  }

  return [...byMethod.values()]
    .sort((a, b) => b.transactions - a.transactions || b.paid - a.paid)
    .map((row) => ({
      ...row,
      transactionsShare: transactions ? row.transactions / transactions : 0,
      paidShare: paid ? row.paid / paid : 0,
    }));
};
